// Exact choices from the university's 2027 information-registration form.
export const REGISTRATION_FORM_VERSION = 'admissions-2027-v1' as const;
export const REGISTRATION_TITLE = 'Đăng ký tìm hiểu thông tin về Trường Đại học Luật TP. HCM năm 2027';
export const SCHOOL_PROVINCES = [
  'An Giang', 'Bắc Ninh', 'Cà Mau', 'Cần Thơ', 'Cao Bằng', 'Đà Nẵng', 'Đắk Lắk',
  'Điện Biên', 'Đồng Nai', 'Đồng Tháp', 'Gia Lai', 'Hà Nội', 'Hà Tĩnh', 'Hải Phòng',
  'Hưng Yên', 'Khánh Hòa', 'Lai Châu', 'Lâm Đồng', 'Lạng Sơn', 'Lào Cai', 'Nghệ An',
  'Ninh Bình', 'Phú Thọ', 'Quảng Ngãi', 'Quảng Ninh', 'Quảng Trị', 'Sơn La', 'Tây Ninh',
  'Thái Nguyên', 'Thanh Hóa', 'Thành phố Huế', 'Thành phố Hồ Chí Minh', 'Tuyên Quang', 'Vĩnh Long',
] as const;
export const INTERESTED_MAJORS = [
  'Ngành Luật', 'Ngành Luật Thương mại quốc tế', 'Ngành Quản trị kinh doanh',
  'Ngành Quản trị - Luật', 'Ngành Kinh doanh quốc tế', 'Ngành Tài chính - Ngân hàng',
  'Ngành Ngôn ngữ Anh', 'Kinh tế số', 'Thương mại điện tử', 'Công nghệ tài chính', 'Ngôn ngữ Trung Quốc',
] as const;
export const SCHOOL_GRADES = ['Khối 10', 'Khối 11', 'Khối 12', 'Khác'] as const;
export const REGISTRATION_ACCURACY = 'Tôi xác nhận và cam kết các nội dung nêu trên là đúng sự thật.';
export const REGISTRATION_CONSENT = 'Tôi đồng ý để Trường Đại học Luật TP. Hồ Chí Minh thu thập, lưu trữ và xử lý các dữ liệu cá nhân do tôi cung cấp trong biểu mẫu này nhằm phục vụ công tác xét tuyển, quản lý hồ sơ, liên hệ và thực hiện các thủ tục liên quan đến việc đăng ký xét tuyển của Trường theo quy định của pháp luật.';
export interface RegistrationAnswers {
  formVersion: typeof REGISTRATION_FORM_VERSION;
  nationalId: string;
  schoolProvince: string;
  interestedMajors: string[];
  grade: string;
  gradeOther: string;
  accuracyConfirmed: boolean;
}
export interface ConsultationInput extends RegistrationAnswers {
  fullname: string;
  school: string;
  email: string;
  phone: string;
  consent: boolean;
}
